<template>
  <div>
    <div class="md:hidden">
      <div v-for="step in steps" :key="step.key">
        <RevSkeleton
          :aria-label="i18n(translations.loading)"
          class="mb-7"
          height="1.8rem"
          shape="rectangle"
          width="100%"
        />
      </div>
    </div>
    <div class="hidden md:block">
      <RevSkeleton
        :aria-label="i18n(translations.loading)"
        class="mb-2"
        height="1.2rem"
        shape="rectangle"
        width="100%"
      />
      <RevSkeleton
        :aria-label="i18n(translations.loading)"
        class="mb-2"
        height="1.2rem"
        shape="rectangle"
        width="100%"
      />
      <RevSkeleton
        :aria-label="i18n(translations.loading)"
        class="mb-2"
        height="1.2rem"
        shape="rectangle"
        width="25%"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevSkeleton } from '@ds/components/Skeleton'

import { type FormattedStatusTimeline } from '@backmarket/nuxt-layer-buyback/utils/adapters'

import translations from './StatusTracker.translations'

defineProps<{
  steps: Array<FormattedStatusTimeline>
}>()
const i18n = useI18n()
</script>
